import { Component, EventEmitter, Optional, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dal-e',
  templateUrl: './dal-e.component.html',
  styleUrls: ['./dal-e.component.scss']
})
export class DalEComponent {

  /** Model key used by ChatFireService (switch-case uses 'dale') */
  readonly modelId = 'dale';

  /** Emit if the user wants to use this model (for non-MatDialog hosts) */
  @Output() selectModel = new EventEmitter<string>();

  /** Emit when closed (for non-MatDialog hosts) */
  @Output() closed = new EventEmitter<void>();

  constructor(@Optional() private dialogRef?: MatDialogRef<DalEComponent>) {}

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.closed.emit();
  }

  useModel(): void {
    if (this.dialogRef) {
      this.dialogRef.close({ selectModel: this.modelId });
    }
    this.selectModel.emit(this.modelId);
  }
}
